import React, { useContext, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import { useIntl } from "react-intl";
import { useSnackbar } from "notistack";
import UserContext from "context/UserContext";
import RevaText from "components/common/RevaText";
import performRequest from "network/perform-request";
import { leagueCustomerMembershipStatusRoute } from "network/api-routes";
import { membershipStatusActions } from "./membership-status";

const MembershipStatusActions = ({ customerId, membership, onChanged }) => {
  const { user } = useContext(UserContext);
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [pendingTarget, setPendingTarget] = useState(null);
  const [saving, setSaving] = useState(false);
  if (!membership) return null;

  const submit = () => {
    setSaving(true);
    performRequest(
      "PATCH",
      leagueCustomerMembershipStatusRoute(customerId, membership.id),
      { status: pendingTarget },
      true,
      user,
    )
      .then(() => {
        setPendingTarget(null);
        enqueueSnackbar(intl.formatMessage({ id: "gestion.accountFinance.membershipStatusUpdated" }), {
          variant: "success",
        });
        onChanged();
      })
      .catch((error) =>
        enqueueSnackbar(error?.response?.data?.message || intl.formatMessage({ id: "gestion.error.generic" }), {
          variant: "error",
        }),
      )
      .finally(() => setSaving(false));
  };

  return (
    <>
      <Stack component="span" direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {membershipStatusActions(membership.status).map(({ target, color }) => (
          <Button
            key={target}
            size="small"
            variant="outlined"
            color={color}
            disabled={saving}
            data-testid={`membership-action-${target}`}
            onClick={() => setPendingTarget(target)}
          >
            {intl.formatMessage({ id: `gestion.accountFinance.membershipAction.${target}` })}
          </Button>
        ))}
      </Stack>
      <Dialog open={pendingTarget !== null} onClose={() => !saving && setPendingTarget(null)} maxWidth="xs" fullWidth>
        <DialogTitle>{intl.formatMessage({ id: "gestion.accountFinance.membershipAction.title" })}</DialogTitle>
        <DialogContent>
          <RevaText variant="body2">
            {pendingTarget && intl.formatMessage({ id: `gestion.accountFinance.membershipConfirm.${pendingTarget}` })}
          </RevaText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPendingTarget(null)} disabled={saving}>
            {intl.formatMessage({ id: "gestion.accountFinance.cancel" })}
          </Button>
          <Button variant="contained" onClick={submit} disabled={saving}>
            {intl.formatMessage({ id: "gestion.accountFinance.membershipAction.confirm" })}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MembershipStatusActions;
